/**
 * Internal dependencies
 */
import { fetchReusableBlocks, saveReusableBlocks, deleteReusableBlocks, convertBlockToReusable, convertBlockToStatic } from './effects/reusable-blocks';
export default {
  FETCH_REUSABLE_BLOCKS: function FETCH_REUSABLE_BLOCKS(action, store) {
    fetchReusableBlocks(action, store);
  },
  SAVE_REUSABLE_BLOCK: function SAVE_REUSABLE_BLOCK(action, store) {
    saveReusableBlocks(action, store);
  },
  DELETE_REUSABLE_BLOCK: function DELETE_REUSABLE_BLOCK(action, store) {
    deleteReusableBlocks(action, store);
  },
  CONVERT_BLOCK_TO_STATIC: convertBlockToStatic,
  CONVERT_BLOCK_TO_REUSABLE: convertBlockToReusable
};
//# sourceMappingURL=effects.js.map